import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'

export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectBarCode = state => {
    return selectOwnState(state).barcode
}

export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}



// WEBPACK FOOTER //
// ./src/modules/process/state/barcode/selector.js